// manikanta 12/22/2022 2700632669 Fixed ErrorSnackBar fields overlapping
// Suresh peddavoora 12/29/2022 2700632669 Fixed toast message alignments
import React, {useState, useEffect} from 'react';
import {Snackbar} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import {makeStyles} from '@material-ui/core/styles';
const useStyles = makeStyles((theme) =>({
  wrap: {
    whiteSpace: 'pre-wrap',
    marginTop: '50px',
    [theme.breakpoints.between('md', 'xl')]: {
      marginTop: '0px',
    },
  },
}));
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const options = {
  autoHideDuration: 6000,
  vertical: 'top',
  horizontal: 'center',
};

export const ErrorSnackbar = ({errorMsg, loginPage}) => {
  const classes = useStyles();
  const textLength = errorMsg?.length;
  let elementWidth ='';
  if (textLength && textLength > 250) {
    elementWidth = '85%';
  } else {
    elementWidth = '40%';
  }
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (errorMsg) {
      setOpen(true);
    }
  }, [errorMsg]);
  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <Snackbar
      style={{width: elementWidth}}
      anchorOrigin={{
        vertical: options.vertical,
        horizontal: options.horizontal,
      }}
      autoHideDuration={loginPage ? 10000 : options.autoHideDuration}
      open={open}
      onClose={handleCloseError}
    >
      <Alert className={classes.wrap} onClose={handleCloseError} severity="error">
        {errorMsg}
      </Alert>
    </Snackbar>
  );
};
export const WarningSnackbar = ({errorMsg, loginPage}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (errorMsg) {
      setOpen(true);
    }
  }, [errorMsg]);
  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: options.vertical,
        horizontal: options.horizontal,
      }}
      autoHideDuration={loginPage ? 10000 : options.autoHideDuration}
      open={open}
      onClose={handleCloseError}
    >
      <Alert onClose={handleCloseError} severity="warning">
        {errorMsg}
      </Alert>
    </Snackbar>
  );
};
export const SuccessSnackbar = ({successMsg}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (successMsg) {
      setOpen(true);
    }
  }, [successMsg]);
  const handleCloseSuccess = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <Snackbar
      anchorOrigin={{
        vertical: options.vertical,
        horizontal: options.horizontal,
      }}
      autoHideDuration={options.autoHideDuration}
      open={open}
      onClose={handleCloseSuccess}
    >
      <Alert onClose={handleCloseSuccess} severity="success">
        {successMsg}
      </Alert>
    </Snackbar>
  );
};
